import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Breadcrumb } from '@app/models/breadcrumb.model';
import { BreadcrumbService } from '@app/shared/breadcrumbs/breadcrumbs.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyDirectoryApiService } from '@app/shared/api/company-directory.api.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CreateCompanyDirectory } from '@app/models/company/company-directory/CreateCompanyDirectory';
import { CreatedCompanyDirectory } from '@app/models/company/company-directory/CreatedCompanyDirectory';
import { environment } from '../../../../../../../environments/environment';
import { IState } from '@app/models/state/state.model';

enum ClipboardField {
  BASE_URL,
  BEARER_TOKEN
}

interface PageState extends IState {
  submitted: boolean;
}

@Component({
  selector: 'app-create-directory',
  templateUrl: './create-directory.component.html',
  styleUrls: ['./create-directory.component.scss']
})
export class CreateDirectoryComponent implements OnInit, OnDestroy {
  public readonly nameMinLength = 1;
  public readonly nameMaxLength = 255;
  public readonly eClipboardField = ClipboardField;
  public readonly copyTimeoutMs = 5000;
  public readonly baseUrl = `${environment.apiUrl}/scim`;

  breadcrumb: Breadcrumb;
  state: PageState;

  form: FormGroup;
  baseUrlCopied: boolean;
  bearerTokenCopied: boolean;

  createdCompanyDirectory?: CreatedCompanyDirectory;

  get controlName(): FormControl {
    return this.form.controls.name as FormControl;
  }

  constructor(
    private readonly breadcrumbService: BreadcrumbService,
    public readonly activatedRoute: ActivatedRoute,
    public readonly router: Router,
    private readonly companyDirectoryApiService: CompanyDirectoryApiService,
    private readonly zone: NgZone
  ) {
    this.createdCompanyDirectory = undefined;
    this.baseUrlCopied = false;
    this.bearerTokenCopied = false;

    this.state = {
      loading: true,
      error: false,
      errorMessage: '',
      submitted: false
    };

    this.breadcrumb = this.breadcrumbService.init(this.activatedRoute);
    this.form = this.initForm();
  }

  ngOnInit(): void {
    this.state.loading = false;
  }

  ngOnDestroy(): void {
    this.breadcrumbService.remove(this.breadcrumb);
  }

  initForm(): FormGroup {
    const formGroup = new FormGroup({
      name: new FormControl('', [Validators.required, Validators.minLength(this.nameMinLength), Validators.maxLength(this.nameMaxLength)])
    });

    return formGroup;
  }

  submitForm(): void {
    if (!this.form.valid) { return console.error('Form is invalid'); }
    this.state.loading = true;
    this.state.submitted = true;

    const createCompanyDirectory: CreateCompanyDirectory = {
      name: this.controlName.value
    };

    this.companyDirectoryApiService.createCompanyDirectory(createCompanyDirectory)
      .toPromise()
      .then(createdCompanyDirectory => {
        this.createdCompanyDirectory = createdCompanyDirectory;
        this.state.loading = false;
      })
      .catch(() => this.state.loading = false);
  }

  timeoutCheckmarkIcon(clipboardField: ClipboardField): void {
    setTimeout(() => {
      this.zone.run(() => {
        switch (clipboardField) {
          case ClipboardField.BASE_URL:
            this.baseUrlCopied = false;
            break;
          case ClipboardField.BEARER_TOKEN:
            this.bearerTokenCopied = false;
            break;
        }
      });
    }, this.copyTimeoutMs);
  }

  navigateBack(): void {
    this.router.navigate([
      '../'
    ], {
      relativeTo: this.activatedRoute
    });
  }
}
